module.exports = " <footer class=footer></footer> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/views/app.footer/AppFooterView.html
// module id = 1035
// module chunks = 0